import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import AgeCalculator from '../../components/AgeCalculator';

const AgeCalcPage: React.FC = () => (
  <ToolLayout
    title="Age Calculator - Calculate Your Exact Age | AllTools"
    description="Calculate your exact age in years, months, days, hours, and minutes. Find your zodiac sign, birthstone, and days until next birthday. Free age calculator."
    canonicalPath="/age-calculator"
  >
    <AgeCalculator />
  </ToolLayout>
);

export default AgeCalcPage;
